import { Transforms, Editor, Node } from 'slate';
import { ReactEditor } from 'slate-react';

const withLists = editor => {
	// Extend default methods
	const { insertBreak, deleteBackward } = editor;

	// List types
	const LISTS = ['bulleted-list', 'numbered-list'];

	// Check if selection is inside list
	// @format: string | list's type
	editor.isInList = format => {
		const [match] = Editor.nodes(editor, {
			match: node => !Editor.isEditor(node) && format ? node.type === format : LISTS.includes(node.type)
		});

		return !!match;
	};

	// Handle's break event inside list
	// @args: default arguments
	editor.insertBreak = (args) => {
		// Proceed with default break insert
		if (!editor.isInList()) return insertBreak(args);

		// Get current list's item
		const [element] = Editor.above(editor, {
			match: node => node.type === 'list-item',
			mode: 'lowest'
		});

		// Check if current list item is empty
		if (Node.string(element) === '') {
			// Unwrap from list container and split selection
			Transforms.unwrapNodes(editor, {
				match: node => LISTS.includes(node.type),
				split: true
			});

			// Set current element as paragraph
			Transforms.setNodes(editor, { type: 'paragraph' });
		} else {
			insertBreak(args);
		}
	};

	// Handle's delete backward event inside list
	// @args: default arguments
	editor.deleteBackward = (...args) => {
		// Proceed with default handler if not in list
		if (!editor.isInList()) return deleteBackward(...args);
		
		// Get current list's item
		const [, path] = Editor.above(editor, {
			match: node => node.type === 'list-item',
			mode: 'lowest'
		});

		// Get achor offset
		const { anchor } = editor.selection;

		// If at the begining of element and it's the first element
		if (anchor.offset === 0 && path[0] === 0) {
			// Unwrap from list container and split selection
			Transforms.unwrapNodes(editor, {
				match: node => LISTS.includes(node.type),
				split: true
			});

			// Set node to default paragraph node
			Transforms.setNodes(editor, {
				type: 'paragraph'
			});
		}
		
		deleteBackward(...args);
	};

	// Toggles selection's type
	// @format: string | list's type
	editor.toggleList = format => {
		// Check if list is active
		const isActive = editor.isInList(format);
		
		// Remove list if current list type
		Transforms.unwrapNodes(editor, {
			match: node => LISTS.includes(node.type),
			split: true
		});

		// Wrap current item in list container
		if (!isActive) Transforms.wrapNodes(editor, { type: format });

		// Set new propertiy
		Transforms.setNodes(editor, {
			type: isActive ? 'paragraph' : 'list-item'
		});

		// Focus editor
		ReactEditor.focus(editor);
	};

	return editor;
};

export default withLists;